import { useEffect, useMemo, useState } from 'react';
import SeasonService from '../services/season.service';
import { PLSeason } from '../types';

export const useGetSeasons = () => {
  const [seasons, setSeasons] = useState<PLSeason[]>([]);
  const [isFetchingSeasons, setIsFetchingSeasons] = useState<boolean>(false);

  const seasonService = useMemo(() => new SeasonService(), []);

  const fetchSeasons = async () => {
    setIsFetchingSeasons(true);
    const seasons = await seasonService.getSeasons();

    setSeasons((seasons?.data as PLSeason[]) ?? []);
    setIsFetchingSeasons(false);
  };

  useEffect(() => {
    fetchSeasons();
  }, []);

  const refetchSeasons = () => {
    fetchSeasons();
  };

  return {
    seasons,
    refetchSeasons,
    isFetchingSeasons,
  };
};
